import { useAssetListClustersQuery } from '@cast/shared-cluster-context-data-access';

type UseDiscoveredClustersArgs = { enabled?: boolean };

export const useDiscoveredClusters = ({
  enabled = true,
}: UseDiscoveredClustersArgs = {}) => {
  const { assetListClusters, isLoading, error, refetch } =
    useAssetListClustersQuery({ enabled });

  return {
    isLoading,
    refetch,
    error,
    discoveredClusters: assetListClusters,
  };
};
